<template>
  <div class="answers_value">
    <vtextarea
      :value="data && data[0] && data[0].body ? data[0].body : answer || ''"
      :disabled="isDisabled"
      :placeholder="$tr('interview.tests.all.questions.answers.answer.value')"
      :prevent-paste-text="is_answer_paste_disabled"
      resizable
      @input="set_answer"
    />
  </div>
</template>

<script>
export default {
  name: 'AnswersValue',

  props: ['data', 'isDisabled', 'is_answer_paste_disabled'],

  data() {
    return {
      answer: ''
    };
  },

  methods: {
    set_answer(v) {
      this.answer = v;
      this.$emit('update', [
        {
          id: this.data[0].id,
          body: v
        }
      ]);
    }
  }
};
</script>

<style lang="scss" scoped>
.answers_value {
  ::v-deep .textarea {
    height: 120px;
  }
}
</style>
